var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from 'react';
import moment from 'moment';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import Page from '../../containers/Page';
import ContactBlocks from '../../ui/ContactBlocks/ContactBlocks';
import CarInvoices from './Tables/CarInvoices';
import ProductInvoices from './Tables/ProductInvoices';
import { Button as MButton, Icon } from '@bytebrand/fe-ui-core-autobahn/ui';
import styles from './BillingPage.styl';
let BillingPage = class BillingPage extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "getNewProductInvoices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.props.invoicesStore.getInvoicesForOdooProductSale('odooProductSale', this.state.startDate, this.state.endDate);
                this.props.invoicesStore.getInvoicesForOdooProductSale('odooCarSale', this.state.startDate, this.state.endDate);
            }
        });
        Object.defineProperty(this, "onSearchButtonClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState({ isUserInSearch: true });
                this.getNewProductInvoices();
            }
        });
        Object.defineProperty(this, "closeSearch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const newStartDate = moment().startOf('month').format('YYYY-MM-DD');
                const newEndDate = moment().endOf('month').format('YYYY-MM-DD');
                this.setState({
                    isUserInSearch: false,
                    startDate: newStartDate,
                    endDate: newEndDate
                }, () => {
                    this.getNewProductInvoices();
                });
            }
        });
        Object.defineProperty(this, "onNewSearch", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.setState({ isUserInSearch: false });
            }
        });
        Object.defineProperty(this, "renderTablesNext", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (jsCarInvoices, jsProductInvoices, error) => {
                const { t, invoicesStore } = this.props;
                if (error)
                    return React.createElement("p", { className: "bl-error" }, t('errorText'));
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "bl-search" }, this.state.isUserInSearch ? (React.createElement("div", { className: "bl-active" },
                        React.createElement("span", null,
                            React.createElement("b", null, t('searchPeriod')),
                            ": ",
                            this.state.startDate,
                            " \u2013 ",
                            this.state.endDate),
                        React.createElement("div", { className: "bl-active-btns" },
                            React.createElement(MButton, { variant: "outlined", size: "sm", onClick: this.onNewSearch }, t('newSearch')),
                            React.createElement("button", { type: "button", className: "bl-reset", onClick: this.closeSearch, "aria-label": "reset" },
                                React.createElement(Icon, { name: "x", size: 16 }))))) : (React.createElement("div", { className: "bl-range" },
                        React.createElement("label", { className: "mfield mfield--sm" },
                            React.createElement("span", { className: "md-label-sm" }, t('searchFrom')),
                            React.createElement("input", { type: "date", value: this.state.startDate, onChange: (e) => this.setState({ startDate: e.target.value }) })),
                        React.createElement("label", { className: "mfield mfield--sm" },
                            React.createElement("span", { className: "md-label-sm" }, t('searchTo')),
                            React.createElement("input", { type: "date", value: this.state.endDate, onChange: (e) => this.setState({ endDate: e.target.value }) })),
                        React.createElement(MButton, { variant: "filled", icon: "search", onClick: this.onSearchButtonClick }, t('searchButton'))))),
                    React.createElement("h2", { className: "md-title bl-section" }, t('carSellHeader')),
                    Object.keys(jsCarInvoices).length
                        ? Object.keys(jsCarInvoices).map((key) => React.createElement(CarInvoices, { date: key, key: key, arrayOfInvoices: jsCarInvoices[key], t: t, getUrl: invoicesStore.getInvoicesAPIURL }))
                        : React.createElement("p", { className: "bl-noresult" }, t('noResultText')),
                    React.createElement("h2", { className: "md-title bl-section" }, t('vexelHeader')),
                    Object.keys(jsProductInvoices).length
                        ? Object.keys(jsProductInvoices).map((key) => React.createElement(ProductInvoices, { date: key, key: key, arrayOfInvoices: jsProductInvoices[key], t: t, getUrl: invoicesStore.getInvoicesAPIURL }))
                        : React.createElement("p", { className: "bl-noresult" }, t('noResultText'))));
            }
        });
        this.state = {
            isUserInSearch: false,
            startDate: moment().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().endOf('month').format('YYYY-MM-DD')
        };
    }
    componentDidMount() {
        this.getNewProductInvoices();
    }
    render() {
        const { t, invoicesStore } = this.props;
        const jsCarInvoices = toJS(invoicesStore.invoicesForOdooCarSale);
        const jsProductInvoices = toJS(invoicesStore.invoicesForOdooProductSale);
        const { error } = invoicesStore;
        return (React.createElement(Page, { page: 'BILLING' },
            React.createElement("div", { className: 'md3 billingPage' },
                React.createElement("div", { className: styles.header },
                    React.createElement("span", { className: styles.headerTitle }, t('headerTitle'))),
                React.createElement(ContactBlocks, { t: t }),
                React.createElement("p", { className: styles.allPricesText }, t('allPrices')),
                React.createElement("div", { className: styles.calculationContainer }, this.renderTablesNext(jsCarInvoices, jsProductInvoices, error)))));
    }
};
BillingPage = __decorate([
    inject('invoicesStore'),
    observer,
    __metadata("design:paramtypes", [Object])
], BillingPage);
export default translate(['BillingPage'])(BillingPage);
